import React, {useEffect, useMemo, useState} from "react";
import { Link } from 'react-router-dom';
import PatientDetailsPanel from "../listPrincipalComponent/TableComponent/PatientDetails";
import PatientMedicalClinicalData from "../listPrincipalComponent/TableComponent/PatientMedicalClinicalData";
import PatientMedicalConsent from "../listPrincipalComponent/TableComponent/PatientMedicalConsent";
import {MaterialReactTable} from "material-react-table";
import {IconButton, MenuItem, Menu} from "@mui/material";
import axios from "axios";
import {
    API_BASE_URL,
    API_GENERIC_PATIENT_DELETE,
    API_PATIENT_LIST
} from "../../../helpers/urlHelper";
import PatientSave from "../listPrincipalComponent/PatientSave";
import PatientAdd from "../button/PatientAdd";
import SearchInput from "../listPrincipalComponent/PatientSearch";
import cityData from "../../../data/cityOptions.json";
import maritalStatusData from "../../../data/maritalStatusOptions.json";
import occupationsData from "../../../data/occupationOptions.json";
import educationLevelsData from "../../../data/educationLevelOptions.json";
import raceEthnicityData from "../../../data/raceEthnicityOptions.json";
import languagesData from "../../../data/languageOptions.json";
import illnessesData from "../../../data/illnesses.json";
import surgeriesData from "../../../data/surgeryOptions.json";
import allergiesData from "../../../data/allergyOptions.json";
import bloodPressureData from "../../../data/bloodPressureOptions.json";
import labTestData from "../../../data/labTest.json";
import treatmentData from "../../../data/treatmentPlans.json";
import referredDate from "../../../data/referredTo.json";
import carePlanData from "../../../data/carePlans.json";
import carePlanTypeData from "../../../data/carePlanTypes.json";
import insuranceData from "../../../data/insuranceProviders.json";
import ActiveFilters from "../listPrincipalComponent/TableComponent/ActiveFilter";
import followUpData from "../../../data/followUpReasons.json";
import FilterOffcanvas from "../listPrincipalComponent/PatientFilter";
import PatientKPIs from "../button/PatientKPI";
import ActionButton from "../button/PatientActions";
import {FaBars} from "react-icons/fa";
import {BsSearch} from "react-icons/bs";
import {useNavigate} from "react-router-dom";
import DoctorManagementMenu from "../../../components/common/Menu/DoctorManagement";
import TopHeader from "../../../components/common/Header/TopHeader";


const PatientsTable = ( ) => {
    const [selectedPatientDetails, setSelectedPatientDetails] = useState(null);
    const [showPanelDetails, setShowPanelDetails] = useState(false);
    const [selectedPatientMedicalConsent, setSelectedPatientMedicalConsent] = useState(null);
    const [selectedPatientMedicalClinical, setSelectedPatientMedicalClinical] = useState(null);
    const [showPanelMedicalClinical, setShowPanelMedicalClinical] = useState(false);
    const [showPanelMedicalConsent, setShowPanelMedicalConsent] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [patients, setPatients] = useState([]);

    const [selectedPatient, setSelectedPatient] = useState(null);
    const [showAddPatientOffcanvas, setShowAddPatientOffcanvas] = useState(false);
    const [showFilterOffcanvas, setShowFilterOffcanvas] = useState(false);
    const [isEdit, setIsEdit] = useState(false);

    const [showKPIs, setShowKPIs] = useState(true);
    const [showActiveFilters, setShowActiveFilters] = useState(true);


    const [isLoading, setIsLoading] = useState(true);

    const navigate = useNavigate();


    const [appliedFilters, setAppliedFilters] = useState({
        name: "",
        surname: "",
        dob: "",
        age: "",
        city: "",
        zipcode: "",
        maritalStatus: "",
        position: "",
        education: "",
        race: "",
        languages: "",
        currentCondition:"",
        currentMedication:"",
        reasonForLastVisit:"",
        lastVisitDate:"",
        upcomingAppointmentDate:"",
        lastAppointmentDate:"",
        completeTreatment:"",
        undergoingTreatment:"",
        referralDate:"",
        planReviewDate:"",
        registrationDate:"",
        createdAt:"",
    });
    const [filterConditions, setFilterConditions] = useState({
        name: "",
        surname: "",
        dob: "",
        age: "",
        city: "",
        zipcode: "",
        maritalStatus: "",
        position: "",
        education: "",
        race: "",
        languages: "",
        currentCondition:"",
        currentMedication:"",
        reasonForLastVisit:"",
        lastVisitDate:"",
        upcomingAppointmentDate:"",
        lastAppointmentDate:"",
        completeTreatment:"",
        undergoingTreatment:"",
    });

    useEffect(() => {
        fetchPatient();
    }, []);

    const fetchPatient = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}${API_PATIENT_LIST}`);
            if (response.data.status) {
                setPatients(response.data.data);
            }
        } catch (error) {
            console.error('Error fetching Patient:', error);
        } finally {
            setIsLoading(false);
        }
    };
    const handleDetailsClick = (patient) => {
        setSelectedPatientDetails(patient);
        setShowPanelDetails(true);
    };

    const handleMedicalClinicalClick = (patient) => {
        setSelectedPatientMedicalClinical(patient);
        setShowPanelMedicalClinical(true);
    };

    const handleMedicalConsentClick = (patient) => {
        setSelectedPatientMedicalConsent(patient);
        setShowPanelMedicalConsent(true);
    };

    const handleDetailTreatmentClick = (patient) => {
        navigate('/patient-treatment-details', {
            state: {
                patientId: patient._id,  // Asegúrate de que el ID del paciente esté disponible
                patientName: `${patient.name} ${patient.surname}`,  // Ajusta los campos según tu API
                patientDob: patient.dob,  // Si necesitas la fecha de nacimiento
                patientEmail: patient.email,  // Si necesitas el email
                patientPhone: patient.phone,  // Si necesitas el teléfono
            },
        });
    };

    const handlePatientClick = (patient) => {
        navigate('/perfilPatientView', {
            state: {
                patientId: patient._id,  // Asegúrate de que el ID del paciente esté disponible
                patientName: `${patient.name} ${patient.surname}`,  // Ajusta los campos según tu API
                patientDob: patient.dob,  // Si necesitas la fecha de nacimiento
                patientEmail: patient.email,  // Si necesitas el email
                patientPhone: patient.phone,  // Si necesitas el teléfono
            },
        });
    };

    const handleElectronicPrescription = (patient) => {
        navigate('/my-electronic-prescriptions', {
            state: {
                patientId: patient._id,  // Asegúrate de que el ID del paciente esté disponible
                patientName: `${patient.name} ${patient.surname}`,  // Ajusta los campos según tu API
                patientDob: patient.dob,  // Si necesitas la fecha de nacimiento
                patientEmail: patient.email,  // Si necesitas el email
                patientPhone: patient.phone,  // Si necesitas el teléfono
            },
        });
    };

    const handleAppointment = (patient) => {
        navigate('/my-appointments', {
            state: {
                patientId: patient._id,  // Asegúrate de que el ID del paciente esté disponible
                patientName: `${patient.name} ${patient.surname}`,  // Ajusta los campos según tu API
                patientDob: patient.dob,  // Si necesitas la fecha de nacimiento
                patientEmail: patient.email,  // Si necesitas el email
                patientPhone: patient.phone,  // Si necesitas el teléfono
            },
        });
    };

    const handlePatientAllergiesClick = (patient) => {
        navigate('/my-allergies', {
            state: {
                patientId: patient._id,  // Asegúrate de que el ID del paciente esté disponible
                patientName: `${patient.name} ${patient.surname}`,  // Ajusta los campos según tu API
                patientDob: patient.dob,  // Si necesitas la fecha de nacimiento
                patientEmail: patient.email,  // Si necesitas el email
                patientPhone: patient.phone,  // Si necesitas el teléfono
            },
        });
    };
    const handlePatientImmunizationsClick = (patient) => {
        navigate('/my-immunizations', {
            state: {
                patientId: patient._id,  // Asegúrate de que el ID del paciente esté disponible
                patientName: `${patient.name} ${patient.surname}`,  // Ajusta los campos según tu API
                patientDob: patient.dob,  // Si necesitas la fecha de nacimiento
                patientEmail: patient.email,  // Si necesitas el email
                patientPhone: patient.phone,  // Si necesitas el teléfono
            },
        });
    };
    const handlePatientVitalsClick = (patient) => {
        navigate('/my-vitals', {
            state: {
                patientId: patient._id,  // Asegúrate de que el ID del paciente esté disponible
                patientName: `${patient.name} ${patient.surname}`,  // Ajusta los campos según tu API
                patientDob: patient.dob,  // Si necesitas la fecha de nacimiento
                patientEmail: patient.email,  // Si necesitas el email
                patientPhone: patient.phone,  // Si necesitas el teléfono
            },
        });
    };
    
    const handlePatientPrescriptionsClick = (patient) => {
        navigate('/my-prescriptions', {
            state: {
                patientId: patient._id,  // Asegúrate de que el ID del paciente esté disponible
                patientName: `${patient.name} ${patient.surname}`,  // Ajusta los campos según tu API
                patientDob: patient.dob,  // Si necesitas la fecha de nacimiento
                patientEmail: patient.email,  // Si necesitas el email
                patientPhone: patient.phone,  // Si necesitas el teléfono
            },
        });
    };
    const handlePatientConditions = (patient) => {
        navigate('/my-conditions', {
            state: {
                patientId: patient._id,  // Asegúrate de que el ID del paciente esté disponible
                patientName: `${patient.name} ${patient.surname}`,  // Ajusta los campos según tu API
                patientDob: patient.dob,  // Si necesitas la fecha de nacimiento
                patientEmail: patient.email,  // Si necesitas el email
                patientPhone: patient.phone,  // Si necesitas el teléfono
            },
        });
    };
    const handlePatientMedications = (patient) => {
        navigate('/my-medications', {
            state: {
                patientId: patient._id,  // Asegúrate de que el ID del paciente esté disponible
                patientName: `${patient.name} ${patient.surname}`,  // Ajusta los campos según tu API
                patientDob: patient.dob,  // Si necesitas la fecha de nacimiento
                patientEmail: patient.email,  // Si necesitas el email
                patientPhone: patient.phone,  // Si necesitas el teléfono
            },
        });
    };
    const handlePatientResults = (patient) => {
        navigate('/my-results', {
            state: {
                patientId: patient._id,  // Asegúrate de que el ID del paciente esté disponible
                patientName: `${patient.name} ${patient.surname}`,  // Ajusta los campos según tu API
                patientDob: patient.dob,  // Si necesitas la fecha de nacimiento
                patientEmail: patient.email,  // Si necesitas el email
                patientPhone: patient.phone,  // Si necesitas el teléfono
            },
        });
    };
    const handlePatientOrders = (patient) => {
        navigate('/my-orders', {
            state: {
                patientId: patient._id,  // Asegúrate de que el ID del paciente esté disponible
                patientName: `${patient.name} ${patient.surname}`,  // Ajusta los campos según tu API
                patientDob: patient.dob,  // Si necesitas la fecha de nacimiento
                patientEmail: patient.email,  // Si necesitas el email
                patientPhone: patient.phone,  // Si necesitas el teléfono
            },
        });
    };

    const handlePatientConsent = (patient) => {
        navigate('/my-consents', {
            state: {
                patientId: patient._id,  // Asegúrate de que el ID del paciente esté disponible
                patientName: `${patient.name} ${patient.surname}`,  // Ajusta los campos según tu API
                patientDob: patient.dob,  // Si necesitas la fecha de nacimiento
                patientEmail: patient.email,  // Si necesitas el email
                patientPhone: patient.phone,  // Si necesitas el teléfono
            },
        });
    };

    // Justo en el cuerpo de PatientsTable, define esto:
    const handleEvaluacionCognitivaClick = (patient) => {
        // Calcula edad a partir de dob si no la tienes ya
        const edad = patient.dob
            ? Math.floor((Date.now() - new Date(patient.dob).getTime()) / (1000 * 60 * 60 * 24 * 365))
            : '';

        navigate('/evaluacion-cognitiva', {
            state: {
                nombre: `${patient.name} ${patient.surname}`,  // ajusta campos según tu API
                edad,
                id: patient._id,
            },
        });
    };


    const columns = useMemo(() => [

        {
    accessorKey: "actions",
    header: "Actions",
    Cell: ({ row }) => {
        const [anchorEl, setAnchorEl] = useState(null);
        const open = Boolean(anchorEl);

        const handleClick = (event) => {
            setAnchorEl(event.currentTarget);
        };

        const handleClose = () => {
            setAnchorEl(null);
        };

        // Función helper para ejecutar acción y cerrar menú
        const handleMenuAction = (action) => {
            handleClose(); // Cerrar menú primero
            action(); // Ejecutar la acción
        };

        return (
            <>
                <IconButton onClick={handleClick}>
                    <p>...</p>
                </IconButton>
                <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                    <MenuItem onClick={() => handleMenuAction(() => handleDetailsClick(row.original))}>
                        Details
                    </MenuItem>
                    <MenuItem onClick={() => handleMenuAction(() => handleMedicalClinicalClick(row.original))}>
                        Medical & Clinical Data
                    </MenuItem>
                    <MenuItem onClick={() => handleMenuAction(() => handleDetailTreatmentClick(row.original))}>
                        Patient Treatment
                    </MenuItem>
                    <MenuItem onClick={() => handleMenuAction(() => handlePatientClick(row.original))}>
                        Patient Perfil View
                    </MenuItem>
                    <MenuItem onClick={() => handleMenuAction(() => handleAppointment(row.original))}>
                        Patient Appointments
                    </MenuItem>
                    <MenuItem onClick={() => handleMenuAction(() => handlePatientPrescriptionsClick(row.original))}>
                        Patient Prescriptions
                    </MenuItem>
                    <MenuItem onClick={() => handleMenuAction(() => handlePatientConditions(row.original))}>
                        Patient Conditions
                    </MenuItem>
                    <MenuItem onClick={() => handleMenuAction(() => handlePatientMedications(row.original))}>
                        Patient Medications
                    </MenuItem>                      
                    <MenuItem onClick={() => handleMenuAction(() => handlePatientAllergiesClick(row.original))}>
                        Patient Allergies
                    </MenuItem>
                    <MenuItem onClick={() => handleMenuAction(() => handlePatientImmunizationsClick(row.original))}>
                        Patient Immunizations
                    </MenuItem>                    
                    <MenuItem onClick={() => handleMenuAction(() => handlePatientResults(row.original))}>
                        Patient Results
                    </MenuItem>
                    <MenuItem onClick={() => handleMenuAction(() => handlePatientVitalsClick(row.original))}>
                        Patient Vitals
                    </MenuItem>  
                    <MenuItem onClick={() => handleMenuAction(() => handleElectronicPrescription(row.original))}>
                        Patient Electronic Prescription
                    </MenuItem>
                    <MenuItem onClick={() => handleMenuAction(() => handlePatientOrders(row.original))}>
                        Patient Orders
                    </MenuItem>
                    <MenuItem onClick={() => handleMenuAction(() => handlePatientConsent(row.original))}>
                        Medical Consent
                    </MenuItem>
                    <MenuItem onClick={() => handleMenuAction(() => handleEvaluacionCognitivaClick(row.original))}>
                        Cognitive Assessment
                    </MenuItem>
                    <MenuItem
                        onClick={() => handleMenuAction(async () => {
                            const userId = row.original._id;
                            const confirmDelete = window.confirm(`Are you sure you want to delete user ${row.original.name}?`);

                            if (confirmDelete) {
                                try {
                                    const url = `${API_BASE_URL}${API_GENERIC_PATIENT_DELETE.replace(":id", userId)}`;
                                    const response = await fetch(url, {
                                        method: "DELETE",
                                        headers: {
                                            "Content-Type": "application/json",
                                        },
                                    });

                                    if (!response.ok) {
                                        throw new Error(`Error: ${response.statusText}`);
                                    }

                                    const data = await response.json();
                                    console.log("User deleted:", data);
                                    fetchPatient();

                                } catch (error) {
                                    console.error("Error deleting user:", error);
                                }
                            }
                        })}
                    >
                        Delete
                    </MenuItem>
                </Menu>
            </>
        );
    },
    size: 50,
},
        {
            accessorKey: "name",
            header: "Name",
            Cell: ({ row }) => {
                console.log('Datos fila:', row.original);
                const { name, surname, imageUrl } = row.original;

                return (
                    <div className="d-flex align-items-center" style={{ cursor: "pointer", textDecoration: "underline" }} onClick={() => handleRowClick(row)}>
                        {imageUrl ? (
                            <img
                                src={imageUrl}
                                alt={`${name} ${surname}`}
                                style={{ width: 30, height: 30, objectFit: "cover", borderRadius: "50%", marginRight: 8 }}
                                onError={e => {
                                    e.target.onerror = null;
                                    e.target.style.display = "none";
                                }}
                            />
                        ) : (
                            <div
                                style={{
                                    width: 30,
                                    height: 30,
                                    borderRadius: "50%",
                                    backgroundColor: "#ccc",
                                    marginRight: 8,
                                }}
                            />
                        )}
                        <span>{name} {surname}</span>
                    </div>
                );
            },
        },


        {
            accessorKey: "phone",
            header: "Phone",
            Cell: ({ row }) => {
                const phonePrefix = row.original.phonePrefix || "";
                const phone = row.original.phone;
                return `${phonePrefix} ${phone.trim()}`;
            },
        },
        {
            accessorKey: "email",
            header: "Email",
        },
        {
            accessorKey: "gender",
            header: "Gender",
        },
        {
            accessorKey: "dob",
            header: "DOB",
        },
        {
            accessorKey: "insuranceCompany",
            header: "Insurance",
        },
        {
            accessorKey: "address",
            header: "Address",
        },
        {
            accessorKey: "medicalHistory",
            header: "Medical History",
        },
    ], [patients ]);

    const handleRowClick = (row) => {
        setSelectedPatient(row.original);
        setIsEdit(true);
        setShowAddPatientOffcanvas(true);
    };
    const handleCloseAddOffcanvas = () => {
        setShowAddPatientOffcanvas(false);
        setSelectedPatient(null);
        setIsEdit(false);
    };
    const handleAddNew = () => {
        setShowAddPatientOffcanvas(true);
    };

    const handleFilterClick = () => {
        setShowFilterOffcanvas(true);
    };
    const handleApplyFilters = () => {
        setAppliedFilters(filterConditions);
        setShowFilterOffcanvas(false);
    };
    const applyFilters = (patients) => {
        return patients.filter(patient => {
            const matchesSearchTerm = searchTerm
                ? ['name', 'phone', 'email'].some(field =>
                    patient[field]?.toLowerCase().includes(searchTerm.toLowerCase())
                )
                : true;

            const matchesFilterConditions = Object.entries(appliedFilters).every(([key, value]) => {
                if (!value) return true;
                return String(patient[key])?.toLowerCase().includes(String(value).toLowerCase());
            });

            return matchesSearchTerm && matchesFilterConditions;
        });
    };
    const filteredPatients = useMemo(() => applyFilters(patients), [patients, appliedFilters, searchTerm]);
    const handleRemoveFilter = (filterKey) => {
        const newFilterConditions = { ...filterConditions };
        delete newFilterConditions[filterKey];
        setFilterConditions(newFilterConditions);
        setAppliedFilters(newFilterConditions);
    };
    const handleClearAll = () => {
        setFilterConditions({});
        setAppliedFilters({});
    };
    const toggleKPIsVisibility = () => {
        setShowKPIs(prevState => !prevState);
    };
    const toggleActiveFiltersVisibility = () => {
        setShowActiveFilters(prevState => !prevState);
    };

    const [rowSelection, setRowSelection] = useState({});

    return (
        <main id="app">
            <TopHeader />

            <div className="content_wrapper">

                <section class="doctor-management-wrapper bg-white pb-5">
                    
                    {/* Inner Menu */}
                    <DoctorManagementMenu activeMenu='patients'/>

                    {/* Body Container */}
                    <div className="container-fluid px-lg-5">

                        {/* Breadcrumb */}
                        <nav className="breadcrumb-container d-none d-md-block pt-3 mb-2" aria-label="breadcrumb">
                            <ol className="breadcrumb fs-sm mb-0">
                                <li className="breadcrumb-item"><Link to="#">Dashboard</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Patients</li>
                            </ol>
                        </nav>

                        {/* KPI Section */}
                        <PatientKPIs patients={filteredPatients} showKPIs={showKPIs} />


                        {/* Action Buttons --- Sección de controles con margen bottom reducido */}
                        <div className="filter-container py-3">
                            <div class="row align-items-center">

                                <div className="col-md-5 col-lg-6 d-none d-md-block mb-3 mb-md-0">
                                    <SearchInput searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
                                </div>

                                <div className="col-md-7 col-lg-6 d-flex justify-content-end gap-1 gap-sm-2 gy-3 flex-wrap">
                                    {/* Action dropdown */}
                                    <ActionButton rowSelection={rowSelection}
                                        filteredPatients={filteredPatients}
                                        className="dropdownbtn"
                                    />
                                    {/* Filter button */}
                                    <Link to="#" className="btn btn-gray filterbtn d-flex align-items-center gap-1 position-relative" 
                                        type="button" 
                                        onClick={handleFilterClick}>
                                        <div className="filter_text d-flex align-items-center gap-1">
                                            <span className="d-block material-symbols-outlined icon-md">tune</span>
                                            <span className="d-block">Filter</span>
                                        </div>
                                        {/* Show badge only if there are active filters */}
                                        {Object.values(appliedFilters).filter(v => v).length > 0 && (
                                            <span 
                                                className="position-absolute top-0 start-100 translate-middle badge rounded-circle bg-primary" 
                                                style={{fontSize: '0.6rem', padding: '0.2rem 0.4rem'}}
                                            >
                                                {Object.values(appliedFilters).filter(v => v).length}
                                            </span>
                                        )}
                                    </Link>
                                    
                                    {/* Add New button */}
                                    <Link to="#" 
                                        className="btn btn-primary addnewbtn d-flex align-items-center gap-1" 
                                        onClick={handleAddNew}
                                        >
                                        <span className="d-block material-symbols-outlined icon-md">add</span>
                                        <span className="d-block">Add New</span>
                                    </Link>

                                </div>
                            </div>
                        </div>

                        {/* Active Filters sin margen adicional */}
                        
                        
                        {showActiveFilters && (
                            
                            <ActiveFilters
                                filterConditions={filterConditions}
                                handleRemoveFilter={handleRemoveFilter}
                                handleClearAll={handleClearAll} />
                            
                        )}

                        {/* Tabla sin margen superior */}
                         <div className="table-wrapper">
                            <MaterialReactTable
                                columns={columns}
                                data={filteredPatients}
                                state={{ isLoading, rowSelection }}
                                onRowSelectionChange={setRowSelection}
                                enableRowSelection={true}
                                enableColumnFilters
                                enableColumnOrdering
                                enableSorting
                                enablePagination />
                        </div>
              


                
                    </div>
                </section>
            </div>

            <FilterOffcanvas
                    showFilterOffcanvas={showFilterOffcanvas}
                    setShowFilterOffcanvas={setShowFilterOffcanvas}
                    filterConditions={filterConditions}
                    handleSearchTermChange={(field, value) => setFilterConditions({ ...filterConditions, [field]: value })}
                    handleSelectChange={(option, field) => setFilterConditions({ ...filterConditions, [field]: option.value })}
                    handleApplyFilters={handleApplyFilters}
                    cityData={cityData}
                    languagesData={languagesData}
                    maritalStatusData={maritalStatusData}
                    occupationsData={occupationsData}
                    educationLevelsData={educationLevelsData}
                    raceEthnicityData={raceEthnicityData}
                    illnessesData={illnessesData}
                    surgeriesData={surgeriesData}
                    allergiesData={allergiesData}
                    bloodPressureData={bloodPressureData}
                    labTestData={labTestData}
                    treatmentData={treatmentData}
                    referredDate={referredDate}
                    carePlanData={carePlanData}
                    carePlanTypeData={carePlanTypeData}
                    insuranceData={insuranceData}
                    followUpData={followUpData}
                    getCurrentSelectValue={(field, options) => options.find(option => option.value === filterConditions[field])} />
                <PatientSave
                    show={showAddPatientOffcanvas}
                    handleClose={handleCloseAddOffcanvas}
                    isEdit={isEdit}
                    patientData={selectedPatient}
                    onPatientSaved={fetchPatient} />
                <PatientDetailsPanel
                    selectedPatientDetails={selectedPatientDetails}
                    showPanelDetails={showPanelDetails}
                    setShowPanelDetails={setShowPanelDetails} />
                <PatientMedicalClinicalData
                    selectedPatientMedical={selectedPatientMedicalClinical}
                    showPanelMedical={showPanelMedicalClinical}
                    setShowPanelMedical={setShowPanelMedicalClinical} />
                <PatientMedicalConsent
                    selectedPatientMedicalConsent={selectedPatientMedicalConsent}
                    showPanelMedicalConsent={showPanelMedicalConsent}
                    setShowPanelMedicalConsent={setShowPanelMedicalConsent} />
        </main>
    );
};

export default PatientsTable;